<div class="overlay-loader" *ngIf="isLoading">
    <div class="spinner-box">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>
<div class="orders-container" *ngIf="loanRequests$ | async as loanRequests">
    <mat-card>
        <mat-card-title>Loan Application Status</mat-card-title>
        <mat-card-content>
            <!-- <table mat-table [dataSource]="loanRequests" class="mat-elevation-z2 orders-table"> -->
            <table mat-table [dataSource]="loanRequests | slice:(pageIndex * pageSize):((pageIndex + 1) * pageSize)"
                class="mat-elevation-z2 orders-table">
                <ng-container matColumnDef="slno">
                    <th mat-header-cell *matHeaderCellDef> Sl No. </th>
                    <td mat-cell *matCellDef="let item; let i = index"> {{ (pageIndex * pageSize) + i + 1 }} </td>
                </ng-container>

                <ng-container matColumnDef="no">
                    <th mat-header-cell *matHeaderCellDef> Loan No. </th>
                    <td mat-cell *matCellDef="let item">{{item.no}}</td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> ID </th>
                    <td mat-cell *matCellDef="let item">{{item.id}}</td>
                </ng-container>

                <ng-container matColumnDef="employee_no">
                    <th mat-header-cell *matHeaderCellDef> Employee No. </th>
                    <td mat-cell *matCellDef="let item">{{item.employee_no}}</td>
                </ng-container>

                <ng-container matColumnDef="employee_name">
                    <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                    <td mat-cell *matCellDef="let item"> {{ item.employee_name }} </td>
                </ng-container>

                <!-- <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef> Amount </th>
                    <td mat-cell *matCellDef="let item"> {{ item.amount }} </td>
                </ng-container> -->

                <ng-container matColumnDef="loan_amount">
                    <th mat-header-cell *matHeaderCellDef> Loan Amount </th>
                    <td mat-cell *matCellDef="let item"> {{ item.loan_amount }} </td>
                </ng-container>


                <ng-container matColumnDef="first_installment_amount">
                    <th mat-header-cell *matHeaderCellDef> First Installment Amount </th>
                    <td mat-cell *matCellDef="let item"> {{ item.first_installment_amount }} </td>
                </ng-container>

                <ng-container matColumnDef="request_date">
                    <th mat-header-cell *matHeaderCellDef> Requested Date </th>
                    <td mat-cell *matCellDef="let item"> {{ item.request_date | date:'dd-MM-yyyy' }} </td>
                </ng-container>

                <ng-container matColumnDef="payment_date">
                    <th mat-header-cell *matHeaderCellDef> Payment Date </th>
                    <td mat-cell *matCellDef="let item"> {{ item.payment_date | date:'dd-MM-yyyy' }} </td>
                </ng-container>

                <ng-container matColumnDef="guarantor">
                    <th mat-header-cell *matHeaderCellDef> Guarantor </th>
                    <td mat-cell *matCellDef="let item"> {{ item.guarantor }} </td>
                </ng-container>

                <ng-container matColumnDef="approval_status">
                    <th mat-header-cell *matHeaderCellDef> Approval Status </th>
                    <td mat-cell *matCellDef="let item"> {{ item.approval_status }} </td>
                </ng-container>

                <ng-container matColumnDef="reason">
                    <th mat-header-cell *matHeaderCellDef> Reason </th>
                    <td mat-cell *matCellDef="let item">
                        <span class="ellipsis-text" [matTooltip]="item.reason">
                            {{ item.reason }}
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <mat-paginator [length]="loanRequests.length" *ngIf="loanRequests.length > 5" [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="onPageChange($event)">
            </mat-paginator>
        </mat-card-content>
    </mat-card>
</div>